export const GALLERY_STATUS = {
  ACTIVE: "active",
  DRAFT: "draft",
  ARCHIVED: "archived",
};

export const GALLERY_CATEGORIES = [
  { value: "wedding", label: "Wedding" },
  { value: "birthday", label: "Birthday" },
  { value: "engagement", label: "Engagement" },
  { value: "maternity", label: "Maternity" },
  { value: "corporate", label: "Corporate" },
  { value: "political", label: "Political" },
  { value: "portrait", label: "Portrait" },
  { value: "other", label: "Other" },
];

export const STATUS_OPTIONS = [
  { value: "active", label: "Active" },
  { value: "draft", label: "Draft" },
  { value: "archived", label: "Archived" },
];

export const ERROR_MESSAGES = {
  FETCH_FAILED: "Failed to fetch galleries. Please try again.",
  FETCH_ONE_FAILED: "Failed to fetch gallery details.",
  CREATE_FAILED: "Failed to create gallery. Please try again.",
  UPDATE_FAILED: "Failed to update gallery. Please try again.",
  DELETE_FAILED: "Failed to delete gallery. Please try again.",
  UPLOAD_FAILED: "Failed to upload images. Please try again.",
  IMAGE_DELETE_FAILED: "Failed to delete image.",
  NOT_FOUND: "Gallery not found.",
  NAME_REQUIRED: "Gallery name is required",
  CATEGORY_REQUIRED: "Category is required",
};

export const SUCCESS_MESSAGES = {
  CREATE_SUCCESS: "Gallery created successfully!",
  UPDATE_SUCCESS: "Gallery updated successfully!",
  DELETE_SUCCESS: "Gallery deleted successfully!",
  IMAGES_UPLOADED: "Images uploaded successfully!",
  IMAGE_DELETED: "Image deleted successfully!",
};
